import * as navigation from 'Navigation';

export default class AgentFactoryTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Factory',
      closeable: false,
      preferenceKey: 'agent-factory',
    };
  }
}
